import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type GithubConnectorConfig = typeof GithubConnector._.Config;

export const GithubConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Github,
  logoPath: 'images/github-logo.svg',
  categories: [IntegrationConnectorCategory.DevOps],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.AppManual,
      configSchema: z.object({
        installationId: z.coerce.number().min(1),
      }),
      encryptedConfigSchema: z.object({}),
    }),
  ]),
});
